import React, { useState } from "react";
import achievementsData from "../data/achievementsData"; // Import the achievements data
import "../CSS/Achievements.css"; // Import corresponding CSS
import { FaMoneyBill, FaMedal, FaCertificate, FaTrophy } from "react-icons/fa";
import linkedinImg from "./assets/linkedin.png"; // Import LinkedIn icon

const awardIcons = {
  cash: <FaMoneyBill title="Cash Award" />,
  "gold medal": <FaMedal style={{ color: "#ffd700" }} title="Gold Medal" />,
  "silver medal": <FaMedal style={{ color: "#c0c0c0" }} title="Silver Medal" />,
  "bronze medal": <FaMedal style={{ color: "#cd7f32" }} title="Bronze Medal" />,
  certificate: <FaCertificate title="Certificate" />,
  trophy: <FaTrophy title="Trophy" />,
  // Add more mappings as needed
};

const Achievements = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [selectedAchievement, setSelectedAchievement] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const toggleTheme = () => {
    document.body.classList.toggle("dark-mode");
    setDarkMode(!darkMode);
  };

  const openModal = (achievement) => {
    setSelectedAchievement(achievement);
    setCurrentImageIndex(0); // Reset image index when opening a new modal
    document.body.classList.add("modal-open");
  };

  const closeModal = () => {
    setSelectedAchievement(null);
    document.body.classList.remove("modal-open");
  };

  const nextImage = () => {
    if (!selectedAchievement) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === selectedAchievement.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    if (!selectedAchievement) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? selectedAchievement.images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="achievements-container">
      <h1 className="achievements-heading">My Achievements</h1>
      <div className="achievements-grid">
        {achievementsData.map((achievement) => (
          <div key={achievement.id} className="achievement-card" onClick={() => openModal(achievement)}>
            <img src={achievement.images[0]} alt={achievement.title} className="achievement-image" />
            {achievement.linkedinLink && (
              <a href={achievement.linkedinLink} target="_blank" rel="noopener noreferrer" className="achievement-linkedin">
                <img src={linkedinImg} alt="LinkedIn" />
              </a>
            )}
            <div className="achievement-info">
              <h3>{achievement.title}</h3>
              <p>{achievement.description}</p>
              <span
                className={`medal ${achievement.awards
                  .filter((award) => award.includes("medal"))
                  .map((award) => award.split(" ")[0])
                  .join(" ")}`}
                title={`${achievement.position} Place`}
              >
                {achievement.position}
              </span>
              <div className="awards-icons">
                {achievement.awards.map((award, idx) => (
                  <span key={idx} className="award-icon">
                    {awardIcons[award.toLowerCase()] || null}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedAchievement && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
          >
            <span
              className="close-button"
              onClick={closeModal}
              aria-label="Close Modal"
              role="button"
              tabIndex="0"
              onKeyPress={(e) => {
                if (e.key === "Enter") closeModal();
              }}
            >
              &times;
            </span>
            <div className="modal-details">
              <div className="detail-section">
                <h2>{selectedAchievement.title}</h2>
                <p>
                  <strong>Place:</strong> {selectedAchievement.position}
                </p>
                <p>
                  <strong>Date:</strong> {selectedAchievement.date}
                </p>
                <p>
                  <strong>Type:</strong> {selectedAchievement.typeOfEvent}
                </p>
                <p>
                  <strong>Location:</strong> {selectedAchievement.location}
                </p>
                <p>
                  <strong>Team/Solo:</strong> {selectedAchievement.teamOrSolo}
                </p>
                {selectedAchievement.teamOrSolo === "Team" && (
                  <p>
                    <strong>Team Members:</strong>{" "}
                    {selectedAchievement.teamMembers}
                  </p>
                )}
                <p>
                  <strong>Role:</strong> {selectedAchievement.role}
                </p>
                <p>
                  <strong>Skills:</strong>{" "}
                  {selectedAchievement.skills.join(", ")}
                </p>
                <p>
                  <strong>Award:</strong>{" "}
                  {selectedAchievement.awards.join(", ")}
                </p>
                <p>
                  <strong>Description:</strong>{" "}
                  {selectedAchievement.additionalInfo ||
                    selectedAchievement.description}
                </p>
              </div>
              <div className="modal-images">
                <button
                  className="carousel-button prev"
                  onClick={prevImage}
                  aria-label="Previous Image"
                >
                  &#10094;
                </button>
                <img
                  src={selectedAchievement.images[currentImageIndex]}
                  alt={`${selectedAchievement.title} ${
                    currentImageIndex + 1
                  }`}
                  loading="lazy"
                />
                <button
                  className="carousel-button next"
                  onClick={nextImage}
                  aria-label="Next Image"
                >
                  &#10095;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Achievements;
